import { useEffect } from 'react';
import TokenRefreshService from '@/services/TokenRefreshService';

export const useTokenRefresh = (onRefresh: () => Promise<void>, enabled = true) => {
  useEffect(() => {
    const service = TokenRefreshService.getInstance();
    
    if (enabled) {
      service.scheduleRefresh(onRefresh);
    } else {
      service.clearSchedule();
    }

    return () => service.clearSchedule();
  }, [onRefresh, enabled]);
};